export default function (Vue, parent, _data) {
  var node_sub_proc = {
    template: `
    <div class='__config__body'> 
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
           <el-form label-width="65px">
            <el-form-item label="唯一标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="节点名称：">
                <el-input v-model="data['name']" :disabled="!params.editable"></el-input>
            </el-form-item>
            <el-form-item label="节点序号：">
                <el-input v-model="data['sn']"></el-input>
            </el-form-item>
            </el-form>
        </el-collapse-item>
        <el-collapse-item title="流程控制" name="2">
           <el-form label-width="92px">
            <el-form-item label="节点类型：">
                <el-select @change='changeType' v-model="data['type']" :disabled="!params.editable">
                  <el-option
                    v-for="item in types"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="目标流程：" v-show="data['type'] === 'sub-proc'">
                <el-input v-model="data['subProcessDefName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showSubProcess">选择</el-button>
            </el-form-item>
            <el-form-item label="目标流程" v-show="false">
                <el-input v-model="data['subProcessDefKey']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="目标流程模块" v-show="false">
                <el-input v-model="data['subProcessModuleId']" :disabled="true"></el-input>
                <el-input v-model="data['subProcessApplicationId']" :disabled="true"></el-input>
            </el-form-item>
            
            <el-form-item label="目标节点：" v-show="data['type'] === 'sub-proc'">
                <el-input v-model="data['subProcessStartActivityName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showSubProcessNode">选择</el-button>
            </el-form-item>
            <el-form-item label="目标节点" v-show="false">
                <el-input v-model="data['subProcessStartActivityId']" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="办理部门：">
                <el-select v-model="data['groupType']">
                  <el-option
                    v-for="item in groupTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="相对部门：" v-show="data['groupType'] === 'relative' ">
                <el-input v-model="data['relativeGroupName']" style="width:60%;" :disabled="true"></el-input>
                <el-button type="primary" @click="showDept">选择</el-button>
            </el-form-item>
             <el-form-item label="相对部门" v-show="false">
                  <el-input v-model="data['relativeGroup']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="部门字段："  v-show="data['groupType'] === 'biz' ">
                <el-input v-model="data['groupField']"></el-input>
            </el-form-item>
            <el-form-item label="部门经办节点：" v-show="data['groupType'] === 'handled-group' ">
                <el-input v-model="data['groupHandledActName']"  :disabled="true" style="width:60%;"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'groupHandled', name:'groupHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="部门经办节点" v-show="false">
                  <el-input v-model="data['groupHandled']" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="部门范围：">
                <el-select v-model="data['group']">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="办理用户：">
                <el-select v-model="data['userType']">
                  <el-option
                    v-for="item in userTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="用户权限：" v-show="data['userType'] === 'role' ">
              <el-input v-model="data['userRoleName']" style="width:60%" :disabled="true"></el-input>
              <el-button type="primary" @click="showRole({id:'userRole', name:'userRoleName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户权限" v-show="false">
              <el-input v-model="data['userRole']" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="用户字段：" v-show="data['userType']=== 'biz' ">
                <el-input v-model="data['userField']"></el-input>
            </el-form-item>
            <el-form-item label="用户经办节点：" v-show="data['userType'] === 'handled-user' ">
                <el-input v-model="data['userHandledActName']"  :disabled="true" style="width:60%"></el-input>
                <el-button type="primary" @click="showHandledNode({id:'userHandled', name:'userHandledActName'})">选择</el-button>
            </el-form-item>
            <el-form-item label="用户经办节点" v-show="false">
                  <el-input v-model="data['userHandled']" :disabled="true"></el-input>
              </el-form-item>
            <el-form-item label="排除条件：">
              <el-radio-group v-model="data['excludeSwitch']" size="mini">
                <el-radio-button label="1">开</el-radio-button>
                <el-radio-button label="0">关</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排除范围：" v-show="data['excludeSwitch']== '1' ">
                <el-select v-model="data['excludeType']">
                  <el-option
                    v-for="item in excludeTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        <el-collapse-item title="表单控制" name="3" >
           <el-form  label-width="85px">
            <el-form-item label="子流程表单：">
               <el-radio-group v-model="data['subProcessFormSwitch']" size="mini">
                <el-radio-button label="1">启用</el-radio-button>
                <el-radio-button label="0">禁止</el-radio-button>
                </el-radio-group> 
            </el-form-item>
            <el-form-item label="表单域映射：" v-show="data['subProcessFormSwitch']=='1' && null!=data['subProcessModuleId'] && data['subProcessModuleId'].length>0">
                <el-button type="primary" @click="showFormFieldMapping()">设置</el-button>
            </el-form-item>
            <el-form-item label="表单域映射" v-show="false">
                <el-input v-model="data['subProcessFormFieldMapping']" :disabled="true"></el-input>
            </el-form-item>
           </el-form>
        </el-collapse-item>
      </el-collapse>
      </div>
    `,
    props: {
      data: {
        type: Object
      },
      params:{
        type: Object
      }
    },
    data() {
      return {
        fields:['id','name','type','sn','type','groupType','group','relativeGroup', 'relativeGroupName',
          'groupField','groupHandled','groupHandledActName','userType','userRole','userRoleName','userField','userHandledActName',
          'userHandled','excludeSwitch','subProcessDefKey','subProcessDefName','subProcessModuleId','subProcessApplicationId',
          'subProcessStartActivityId','subProcessStartActivityName','excludeType','subProcessFormSwitch','subProcessFormFieldMapping'],

        activeName: '1',
        types:[],
        groupTypes:[{value:'role',label:'权限'},{value:'relative',label:'相对部门'},{value:'handled-group',label:'经办'},{value:'biz',label:'业务指定'},{value:'upper-group',label:'发送部门'},{value:'draft-group',label:'发起部门'}],
        groups:[{value:'<当前>', label:'<当前>'},{value:'<上级>', label:'<上级>'}, {value:'<下级>', label:'<下级>'}, {value:'<平级>', label:'<平级>'},
          {value:'<当前和上级>', label:'<当前和上级>'},{value:'<当前和下级>', label:'<当前和下级>'},
          {value:'<所有下级>', label:'<所有下级>'}, {value:'<上级的平级>', label:'<上级的平级>'},
          {value:'<本部门任选>', label:'<本部门任选>'},{value:'<部门上级>', label:'<部门上级>'}, {value:'<部门下级>', label:'<部门下级>'}, {value:'<部门平级>', label:'<部门平级>'},
          {value:'<本单位任选>', label:'<本单位任选>'},{value:'<本单位任选(不包含下级)>', label:'<本单位任选(不包含下级)>'},
          {value:'<本单位的一级部门>', label:'<本单位的一级部门>'},{value:'<单位上级>', label:'<单位上级>'},{value:'<单位平级>', label:'<单位平级>'},
          {value:'<上级单位部门>', label:'<上级单位部门>'},{value:'<上级单位任选>', label:'<上级单位任选>'}/*, {value:'<任选>', label:'<任选>'}*/],
        userTypes:[{value:'role',label:'权限'}, {value:'handled-user',label:'经办'},{value:'biz',label:'业务指定'},{value:'draft-user',label:'发起人'},{value:'upper-user',label:'发送人'}],
        excludeTypes:[{value:'current-user', label:'当前用户'},{value:'current-dep', label:'当前部门'}]
      };
    },
    created() {
      let me=this;
      me.clearField();
      me.types=me.params.activityTypes;
      me.initData();
    },
    watch: {
      'data.name': function (val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", {id: me.data.id, name: val})
        }
      },
      'data.id': function (val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name
          this.$set(this.data, 'name', '新增节点')
        }
        this.initData();
      }
    },
    methods: {
      initData(){
        var me = this;
        if (me.data.name == undefined) {
          this.$set(me.data, 'name', '新增节点')
        }
        if(this.data.excludeSwitch == undefined){
          this.$set(this.data, 'excludeSwitch', '0');
        }

        if(this.data.type == undefined){
          this.$set(this.data, 'type', 'sub-proc');
        }

        if(this.data.groupType == undefined){
          this.$set(this.data, 'groupType', this.groupTypes[0].value);
        }

        if(this.data.group == undefined){
          this.$set(this.data, 'group', '<当前>');
        }

        if(this.data.userType == undefined){
          this.$set(this.data, 'userType', this.userTypes[0].value);
        }
        if(this.data.excludeType == undefined){
          this.$set(this.data, 'excludeType', this.excludeTypes[0].value);
        }
        if(this.data.subProcessFormSwitch == undefined){
          this.$set(this.data, 'subProcessFormSwitch', '1');
        }
      },
      showHandledNode(f){
        var me =  this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        PF.show('tree',{treeData:me._getActivities(['start','end','circular','sub-proc']), selectFirst:false, selectNode:selectNode},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });

      },
      showDept(){
        var me  = this;
        var selectNode = '';
        if(me.data['relativeGroup']){
          selectNode = me.data['relativeGroup'];
        }
        PF.show('tree',{url: this.mwUrl("/api/org/listDepartment"), selectFirst:false,selectNode:selectNode, search:true, async:true, singleLeaf:false},function(res){
          me.$set(me.data,'relativeGroup',res.id);
          me.$set(me.data,'relativeGroupName',res.name);
        });
      },
      showRole(f){
        var me  = this;
        var selectNode = '';
        if(me.data[f.id]){
          selectNode = me.data[f.id];
        }
        PF.show('tree',{url: this.mwUrl("/api/org/listFlowGroupedRole"), selectFirst:false,selectNode:selectNode, search:true,clearBtn:true},function(res){
          me.$set(me.data,f.id,res.id);
          me.$set(me.data,f.name,res.name);
        });
      },

      showSubProcess(){
        var me = this;
        var selectNode = '';
        if(me.data.subProcessDefKey){
          if(me.data.subProcessModuleId){
            selectNode = me.data.subProcessDefKey+'|'+me.data.subProcessModuleId;
          }else{
            selectNode = me.data.subProcessDefKey;
          }
        }
        PF.show('tree',{url: this.mwUrl("/api/process/listModuleLatestProcDefTree"), singleLeaf:true, selectFirst:false,selectNode:selectNode, search:true, defaultParams:{sysId:me.params.sysId}},function(res){
          if(res) {
            if(res.id) {
              var ids = res.id.split('|');
              me.$set(me.data, 'subProcessDefKey', ids[0]);
            } else {
              me.$set(me.data, 'subProcessDefKey', res.id);
            }
            me.$set(me.data, 'subProcessDefName', res.name);
            me.$set(me.data, 'subProcessApplicationId', res.appId);
            me.$set(me.data, 'subProcessModuleId', res.moduleId);
            delete me.data.subProcessStartActivityId;
            delete me.data.subProcessStartActivityName;
            delete me.data.subProcessFormFieldMapping;
          }
        });
      },
      showSubProcessNode(){
        var me = this;
        var key = me.data.subProcessDefKey;
        if(key){
          var selectNode = '';
          if(me.data['subProcessStartActivityId']){
            selectNode = me.data['subProcessStartActivityId'];
          }
          var appId = me.params.applicationId;
          if(me.data.subProcessApplicationId){
            appId = me.data.subProcessApplicationId;
          }
          PF.show('tree',{url: this.mwUrl("/api/process/getSubProcessStartActivities"), selectFirst:false, selectNode:selectNode,defaultParams:{key:key, appId:appId}},function(res){
            me.$set(me.data,'subProcessStartActivityId',res.id);
            me.$set(me.data,'subProcessStartActivityName',res.name);
          });
        }
      },
      showFormFieldMapping(){
        var me = this;
        var moduleId = me.params.moduleId;
        var subProcessDefKey = me.data.subProcessDefKey;
        if(!subProcessDefKey){
            me.mwMsg('info', '请先选择一个目标流程!');
            return;
        }
        var formFieldMapping = [];
        if(me.data.subProcessFormFieldMapping){
          formFieldMapping = JSON.parse(me.data.subProcessFormFieldMapping);
        }
        PF.show('processFormFieldMapping',{moduleId:moduleId, subProcessModuleId:me.data.subProcessModuleId, formFieldMapping:formFieldMapping,applicationId:me.params.applicationId},function(res){
          var data = res.data;
          if(!data){
            data = [];
          }
          me.$set(me.data,'subProcessFormFieldMapping',JSON.stringify(data));
        });
      },
      clearField:function(){
        var me=this;
        function contains(obj) {
          for(var i=0;i<me.fields.length;i++){
            if(me.fields[i]==obj){
              return true
            }
          }
          return false;
        }
        var del=[]
        for(var s in me.data){
          if(!contains(s)){
            del.push(s)
          }
        }
        for(var i=0;i<del.length;i++){
          delete me.data[del[i]]
        }
      },
      changeType:function(val){
        parent.$emit("updateShape", {id: this.data.id, type: val})
        this.params.changeType(val);
      },
      _getActivities(excludeActivityTypes){
        var me = this;
        var processDataItems = me.params.processDataItems;
        var activities = processDataItems.ACTIVITY;
        var treeData = [];
        var exclude;
        activities.forEach(a=>{
          exclude = false;
          excludeActivityTypes.forEach(et=>{
            if(et==a.extends){
              exclude = true;
            }
          });
          if(!exclude){
            treeData.push({id:a.id, text:a.parameters.name, name:a.parameters.name});
          }
        });
        return treeData;
      }
    }
  }
  return node_sub_proc
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/node_sub_proc.js